var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTailArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1999 9.52665C11.9399 9.26665 11.5199 9.26665 11.2599 9.52665L8.66657 12.1133V1.99998C8.66657 1.63331 8.36657 1.33331 7.99991 1.33331C7.63324 1.33331 7.33324 1.63331 7.33324 1.99998V12.12L4.74657 9.53331C4.48657 9.27331 4.06657 9.27331 3.80657 9.53331C3.54657 9.79331 3.54657 10.2133 3.80657 10.4733L7.53324 14.2C7.79324 14.46 8.21324 14.46 8.47324 14.2L12.1999 10.4733C12.4532 10.2133 12.4532 9.78665 12.1999 9.52665Z",
    fill: "#C4CDD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTailArrowDown);
export default __webpack_public_path__ + "static/media/ico-tail-arrow-down.3b8720d4216eefd228e228fda7a28eb1.svg";
export { ForwardRef as ReactComponent };